<template >

  <div class="container " >
    <form action="" @submit.prevent="submit">
      <div class="card">
        <div class="card-header">
          <h6><i class="fa fa-address-book"></i><span class="tab-txt"> البيانات الاساسية </span></h6>
        </div>
        <div class="card-body">
          <div class="form row">
          <div class="form-group col-md-3">
             <label for="">كود الباص</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.busID.$model"
                :class="{
                  'is-invalid': $v.busID.$error,
                  'is-valid': !$v.busID.$invalid,
                }"
              >
             <option v-for="bus in buses" :value="bus.id" :key="bus.id">
             {{ bus.id }} 
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.busID.required">هذا الحقل مطلوب</span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">نوع الصيانة</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.mainType.$model"
                :class="{
                  'is-invalid': $v.mainType.$error,
                  'is-valid': !$v.mainType.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.mainType.required">هذا الحقل مطلوب</span>
              
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">تكلفة قطع غيار</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.coseMain.$model"
                :class="{
                  'is-invalid': $v.coseMain.$error,
                  'is-valid': !$v.coseMain.$invalid,
                }"
              />
              <div class="invalid-feedback">
             
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">تفاصيل الصيانة</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Details.$model"
                :class="{
                  'is-invalid': $v.Details.$error,
                  'is-valid': !$v.Details.$invalid,
                }"
              />
              <div class="invalid-feedback">
               
              </div>
            </div>

             <div class="form-group col-md-3">
             <label for="">المكلف بالصيانة</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.empFollow.$model"
                :class="{
                  'is-invalid': $v.empFollow.$error,
                  'is-valid': !$v.empFollow.$invalid,
                }"
              >
             <option v-for="emp in emps" :value="emp.id" :key="emp.id">
          <span> {{ emp.Fname }}  </span>  <span> {{ emp.Ffname }} </span> 
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.empFollow.required">هذا الحقل مطلوب</span>
              </div>
            </div>

             <div class="form-group col-md-3">
              <label for="">تاريخ البدء</label>
             
              <input
                id="mainStart"
                type="text"
                @blur="mainStart1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.mainStart.$model"
                :class="{
                  'is-invalid': $v.mainStart.$error,
                  'is-valid': !$v.mainStart.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.mainStart.required">هذا الحقل مطلوب</span>
              </div>
            </div>

     
 <div class="form-group col-md-3">
              <label for="">تاريخ الانتهاء </label>
             
              <input
                id="mainEnd"
                type="text"
                @blur="mainEnd1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.mainEnd.$model"
                :class="{
                  'is-invalid': $v.mainEnd.$error,
                  'is-valid': !$v.mainEnd.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.mainEnd.required">هذا الحقل مطلوب</span>
              </div>
            </div>

               <div class="form-group col-md-3">
              <label for="">تكلفة الصيانة</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.totalCost.$model"
                :class="{
                  'is-invalid': $v.totalCost.$error,
                  'is-valid': !$v.totalCost.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.totalCost.required">هذا الحقل مطلوب</span>
             
              </div>
            </div>
          </div>
        </div>
      </div>


        <div class="card">
          <div class="card-header">
            <h6><i class="fa fa-cog"></i><span class="tab-txt"> التحكم </span></h6>
          </div>
          <div class="card-body">
            <div class="form row">
              <button
                class="btn btn-success"
                type="submit"
                :disabled="submitStatus === 'انتظار'"
              >
              <b-spinner
v-if="busy"
small
type="grow"
style="margin-bottom: 3px;"
></b-spinner>
              <i class="fa fa-paper-plane"></i>
               <span> {{submitStatus}} </span>
              </button>
               <b-button
                class="btn btn-info mr-3"
                type="button"
                to="/busMain"
              >
              <i class="fa fa-undo"></i>
               <span> عودة </span>
              </b-button>
            </div>
          </div>
        </div>
    </form>

  </div>
</template>





<script>
  import { mapState,mapActions  } from 'vuex';
 import $ from 'jquery'
import indexLayout from "../../layouts/indexLayout.vue";


import {
  required,
} from "vuelidate/lib/validators";
export default {
  name: "createEmp",
  data() {
    return {
busID:"",
mainType:"",
coseMain:"",
Details:"",
empFollow:"",
mainStart:"",
mainEnd:"",
totalCost:"",
busy:false,
      submitStatus: "حفظ",
    };
  },
  validations: {
    
    busID: { required },
    mainType: { required},
    coseMain: {  },
    Details: {  },
    empFollow: { required },
    totalCost: {  },
 
    mainStart: { 
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    },
    mainEnd: { 
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    }
  

  },
  methods: {
   ...mapActions('busMainMod',['addData']),
  mainStart1(){
        var st = $('#mainStart').val();
        this.mainStart = st;
   },
  mainEnd1(){
        var st = $('#mainEnd').val();
        this.mainEnd = st;
   },
   async submit() {
      this.$v.$touch();
      this.busy=true;
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
        this.busy=false;
      } else {
       var std = {
busID:this.busID,
mainType:this.mainType,
coseMain:this.coseMain,
Details:this.Details,
empFollow:this.empFollow,
mainStart:this.mainStart,
mainEnd:this.mainEnd,
totalCost:this.totalCost,
}
         await  this.addData(std);       

        this.submitStatus = "الانتظار";
        setTimeout(() => {
          this.submitStatus = "تم الحفظ";
        }, 500);
        this.busy=false;
      }
    },
  },created(){

let ckeditor = document.createElement('script'); 
//ckeditor.setAttribute('src',"/load.js");
ckeditor.innerHTML = "$(function () { initHijrDatePicker();  });";
document.head.appendChild(ckeditor);
this.$emit('update:layout',indexLayout)


  }
  ,mounted(){
    
  
  },
  computed: mapState([
     'emps',            
    'buses',
     
  ])
};
</script>

<style lang="scss" scoped>
span{
  font-size: 12px;
}
</style>
